module.exports = __webpack_public_path__ + "media/motown2.4d83d7e0.mp4";